import { translate } from "@klantondersteuning-btl/shared";
import * as React from "react";

export const IntroEN = () => {
  return (
    <div className="pt-4 intro">
      <h1>{translate("EhicFormulier")}</h1>
      <p>
        Use this form to apply for an EHIC for a family member. This is only possible after the registration
        date with the CAK. Complete a separate form for each family member who is insured via the CAK.
      </p>
      <p className="form-notification-block form-notification-block--tip">
        <strong>Tip</strong>
        <br />
        This form is for family members of employees only. Do you receive a Dutch pension or benefit and do
        you live abroad? You and your family members will then receive the EHIC automatically.
      </p>
      <br />
    </div>
  );
};
